<template>
  <RuesBoxSize v-if="objekte.length !== 0" :size="props.item?.width" class="text-left grid grid-cols-1 gap-y-6">
    <UiHeadline v-if="props.item?.headline" type="h2" design="h2">
      {{ props.item?.headline }}
    </UiHeadline>

    <div class="grid grid-cols-1 gap-y-6">
      <div
        v-for="objekt in objekte"
        :key="objekt.id"
        class="border border-neutral-200 rounded-xl overflow-hidden flex flex-col md:flex-row"
      >
        <UiMaskedLink
          :aria-label="objekt.hausname"
          :href="objekt.url"
          :new-tab="true"
          class="relative md:w-2/5 lg:w-1/3 shrink-0"
        >
          <!-- Absolutely filled on md+ so the text column alone defines the card height and
               the image aspect ratio cannot stretch the element (TR-36884). -->
          <img
            :src="objekt.bilder_neu?.[0]"
            class="object-cover object-center w-full h-56 bg-neutral-100 md:absolute md:inset-0 md:h-full"
            :alt="objekt.hausname"
            loading="lazy"
          >
        </UiMaskedLink>

        <div class="flex flex-col grow p-5 gap-y-2">
          <div class="text-sm text-gray-600">
            <UiIcon src="/svg/icons/location.svg" height="12px" width="12px" class="fill-neutral-600 -mt-[1px] inline-block" />
            {{ objekt.region }}
            <span class="mx-0.5">·</span>
            {{ objekt.ortsname }}
          </div>

          <UiMaskedLink :masking-disabled="true" :masking-aria-label="objekt.hausname" :href="objekt.url" :new-tab="true">
            <UiHeadline design="h3" type="h3">
              {{ objekt.hausname }}
            </UiHeadline>
          </UiMaskedLink>

          <SharedStars
            :rating="objekt.bewertung"
            :number-of-reviews="objekt.bewertungen"
            design="compact_card"
          />

          <p class="text-neutral-700 grow">
            {{ objekt.summary_text }}
          </p>

          <div class="flex flex-row items-end justify-between gap-3 mt-2">
            <div>
              <span class="text-sm text-gray-600">
                {{ t('from') }}
                <span class="font-semibold text-neutral-900 text-xl ml-0.5">{{ usePrices().totalPrice(objekt.preis_min) }}</span>
              </span>
              <span class="text-sm text-gray-600">
                {{ t('night') }}
              </span>
            </div>
            <UiButton color="petrol" :href="objekt.url" class="shrink-0">
              {{ t('cta_button') }}
            </UiButton>
          </div>
        </div>
      </div>
    </div>
  </RuesBoxSize>
</template>

<script setup lang="ts">
import type { ObjektTeaserMitKiZusammenfassungElementData, SolrResultItemDTO } from '~/types/TypesFromPortalBackend'

type TeaserObjekt = SolrResultItemDTO & { summary_text?: string }

interface Props {
  item?: ObjektTeaserMitKiZusammenfassungElementData | null
}
const props = withDefaults(defineProps<Props>(), {
  item: null
})

const { translate: t } = useTranslations('RuesProductAiSummary')

const objekte = computed<TeaserObjekt[]>(() => (props.item?.objekte ?? []) as TeaserObjekt[])
</script>
